import { AppBar, Toolbar } from "@mui/material";
import {
	DeleteButton,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	ResetButton,
	SplitButton,
	SubmitButton,
} from "@websential/cosmic-v20";

import { FC } from "react";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";

// import { SplitButton } from "./SplitButton";

export interface IPayrollAdjustmentSetupToolbar {
	payrollScreenPermissions:any;
	onSubmitButtonClickedHandler: () => void;
	onCalculatePayrollClicked: () => void;
	// onInsertButtonClicked: (selectedItem: any) => void;
	onInsertButtonClicked: () => void;
	onDeleteEmployeePayrollDataClicked: () => void;
	haveCalculatedTable: boolean;
	payrollAdjustmentTableData: any;
}

export const PayrollAdjustmentSetupToolbar: FC<IPayrollAdjustmentSetupToolbar> = ({
	onSubmitButtonClickedHandler,
	onCalculatePayrollClicked,
	onInsertButtonClicked,
	onDeleteEmployeePayrollDataClicked,
	haveCalculatedTable,
	payrollAdjustmentTableData,
	payrollScreenPermissions
}) => {
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			data-testId={""}
			sx={{
				backgroundColor: "#fff",
				// // marginTop: theme.spacing(3),
				boxShadow: "none",
				alignItems: "center",
				zIndex: 0,
				// position: "sticky",
				// bottom: 0,
				// top: 'auto',
				// bottom: 0,
				// backgroundColor: '#fff',
				// boxShadow: 'none',
				// alignItems: 'center',
				// zIndex: (theme) => theme.zIndex.drawer + 1, // ensure above other elements

				paddingBottom: haveCalculatedTable ? "5rem" : ""
			}}
		>
			<Toolbar>
				<EnhancedButtonPrimeReact
					label="Save"
					// type="submit"
					onClickHandler={onSubmitButtonClickedHandler}
					// icon="pi pi-check"
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>
				<EnhancedButtonPrimeReact
					label="Insert"
					// type="submit"
					onClickHandler={onInsertButtonClicked}
					// icon="pi pi-check"
					raised
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
					style={{ marginRight: "1rem" }}
				/>
				{/* <SplitButton
					options={["Insert Gross Hours", "Insert Gross", "Insert Hours", "Insert Previous", "Insert EDR"]}
					onClickHandler={onInsertButtonClicked}
					testId="t4-print-button"
				// icon={"pi pi-sign-in"}
				// listItemsLabel={`Print T4 Slips `}

				/> */}
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Delete"
					raised
					onClickHandler={onDeleteEmployeePayrollDataClicked}
					// style={{ marginLeft: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
				/>
				{/* {payrollScreenPermissions && payrollScreenPermissions["Calculate Payroll"] && payrollScreenPermissions["Calculate Payroll"] ? <EnhancedButtonPrimeReact
					label="Calculate Payroll"
					raised
					onClickHandler={onCalculatePayrollClicked}
					style={{ marginLeft: "1rem" }}
					disabled={payrollAdjustmentTableData.items.some((item: any) => item.salaryProfileMessage !== null)}
				/> : <></>} */}
				<EnhancedButtonPrimeReact
					label="Calculate Payroll"
					raised
					onClickHandler={onCalculatePayrollClicked}
					style={{ marginLeft: "1rem" }}
					// disabled={payrollAdjustmentTableData.items.some((item: any) => item.salaryProfileMessage !== null)}
				/>
			</Toolbar>
		</AppBar>
	);
};
